/**
 * Translation resources for the supported English spellings.
 *
 * This is an intentionally small starter set of words that differ between
 * British and American English. Add to these bundles as more copy is migrated
 * to react-i18next — keep the keys identical across every language.
 *
 * Convention: keys are named with their British spelling (e.g. `colour`,
 * `organise`) so they read naturally alongside the rest of the codebase. Note
 * that in the `en-US` bundle such a key resolves to its American value
 * (e.g. `colour` -> "Color"); the key name reflects the concept, not the
 * resolved spelling.
 */
export const enGB = {
  translation: {
    common: {
      colour: "Colour",
      customise: "Customise",
      organise: "Organise",
      personalise: "Personalise",
      cancelled: "Cancelled",
      centre: "Centre",
      favourite: "Favourite",
      apologise: "Apologise"
    }
  }
} as const;

export const enUS = {
  translation: {
    common: {
      colour: "Color",
      customise: "Customize",
      organise: "Organize",
      personalise: "Personalize",
      cancelled: "Canceled",
      centre: "Center",
      favourite: "Favorite",
      apologise: "Apologize"
    }
  }
} as const;

export const resources = {
  "en-GB": enGB,
  "en-US": enUS
} as const;
